module.exports = __webpack_public_path__ + "img/ika-footer.85e069d8.png";